export default {
	name: 'task_0_4',
	description: 'Заставка',
	title: 'Режим прохождения игры',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите режим прохождения игры",
			options: ["Обучающий", "Контрольный"],
			correct: [1]
        };
	},
	/* messages() {
		return {
            onStart: "Тестовый текст",
			onFinish: () => "Тестовый финиш",
		};
	}, */
	isCompleted: () => true,
};